import { render, staticRenderFns } from "./InquiryContactInfo.vue?vue&type=template&id=16ba705d&"
import script from "./InquiryContactInfo.vue?vue&type=script&lang=js&"
export * from "./InquiryContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports